// Lightweight visitor analytics tracker.
// Generates a stable session_id in localStorage, POSTs events to /api/analytics/track.
// Auto-tracks page_view on route changes when init() is called.
import api from "@/lib/api";

const SESSION_KEY = "kb_visitor_session_id";

function uuid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return Array.from({ length: 16 }, () => Math.floor(Math.random() * 16).toString(16)).join("");
}

function getSessionId() {
  if (typeof localStorage === "undefined") return "anon";
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = uuid();
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

export async function track(eventType, payload = {}, page) {
  try {
    await api.post("/analytics/track", {
      session_id: getSessionId(),
      event_type: eventType,
      page: page || (typeof window !== "undefined" ? window.location.pathname : ""),
      payload,
      referrer: typeof document !== "undefined" ? document.referrer : "",
    });
  } catch {
    // swallow — tracker must never break UX
  }
}

let lastTrackedPath = null;
export function trackPageView() {
  if (typeof window === "undefined") return;
  const p = window.location.pathname + window.location.search;
  if (p === lastTrackedPath) return;
  lastTrackedPath = p;
  track("page_view", {}, p);
}
